// Teksten van het woonkamerbord (docs/DESIGN.md §8.K1–K7), sprint 2/3. Apart bestand zodat nl.ts
// klein blijft; de sleutels staan in `m.kiosk.*` (gespreid in nl.ts). Je-vorm, kort, icoon eerst.
export const kioskBoardNl = {
    // Agenda
    weekToggle: 'Week',
    weekTitle: 'Week {week}',
    // Oprichter 1 okt 2026: de huidige week heet op het bord "Vandaag - Week 40".
    weekTitleToday: 'Vandaag - Week {week}',
    backToToday: 'Vandaag',
    // UX-ronde bord 2: knop in de kop met de minder gebruikte ingangen (Berichten, Wensen, ...).
    menu: 'Meer',
    // Restpunten 6 okt 2026: de groepen van de popup Meer en de bevestiging van het
    // ververs-gebaar (drie tikken op het logo).
    menuMake: 'Maken',
    menuHome: 'Thuis',
    menuBoard: 'Bord',
    boardRefreshing: 'Verversen…',
    boardLoading: 'Laden…',
    boardRefreshFailed: 'Verversen lukte niet: geen verbinding. Het bord toont de laatst bekende gegevens.',
    pageOf: 'Pagina {n} van {total}',
    prevWeek: 'Vorige week',
    nextWeek: 'Volgende week',
    weekEmpty: 'Deze week is nog leeg',
    // Agendapagina van het bord (oprichter 1 okt 2026): Dag/Week, filter op personen.
    modeDay: 'Dag',
    modeWeek: 'Week',
    agendaMode: 'Weergave',
    prevDay: 'Vorige dag',
    nextDay: 'Volgende dag',
    filterPeople: 'Laat zien voor',
    noEventsWeek: 'Geen afspraken deze week',
    noEventsDay: 'Geen afspraken op deze dag',
    noEventsFor: 'Niets gepland voor {names}',
    // Maandweergave van de agendapagina (oprichter 1 okt 2026).
    modeMonth: 'Maand',
    prevMonth: 'Vorige maand',
    nextMonth: 'Volgende maand',
    noEventsMonth: 'Geen afspraken deze maand',
    // Reistijd-knop op de agendapagina (oprichter 1 okt 2026): ritten tonen of verbergen.
    travelToggle: 'Reistijd',
    rideBring: 'Brengen',
    rideFetch: 'Halen',
    rideOnTheWay: 'Onderweg',
    rideBack: 'Terug',
    moreItems: '+{count}',
    laterAt: 'Straks · {time}',
    nowUntil: 'Nu · tot {time}',
    scrollMore: 'Meer afspraken',
    tasksMore: 'Meer taken',
    tasksLess: 'Terug naar boven',
    departClose: 'Melding sluiten',
    departWho: '{names}: om {time} weg naar {title}',
    // Rijders op de detailkaart (oprichter 1 okt: alles vertaald).
    rideDropoff: '{name} brengt',
    ridePickup: '{name} haalt',
    and: 'en',
    travel: '{minutes} min onderweg',
    leaveAt: 'weg om {time}',
    /** 0056: reistijd terug: thuis rond deze tijd. */
    travelBack: 'thuis om {time}',
    conflict: 'Tegelijk met iets anders',
    continues: 'Loopt door',
    tomorrowFirst: 'Morgen {time}: {title}',
    // Taken
    waitingApproval: 'Wacht op papa/mama',
    // Grote Klaar-popup (oprichter 1 okt 2026): taak met goedkeuring.
    klaarApproval: 'Papa of mama keurt het nog goed.',
    doneBy: '{name} was eerst',
    claimedBy: '{name} doet dit',
    tryAgain: 'Nog een keer?',
    notSaved: 'Dat lukte niet',
    cloudPending: 'Wordt bewaard…',
    memberRail: 'Gezinsleden',
    pointsReserved: '{count} gereserveerd',
    // Beloningen
    rewardsTile: 'Beloningen',
    rewardsOf: 'Beloningen van {name}',
    goal: 'Doel: {name}',
    goalProgress: '{value} van {max}',
    goalHint: 'Kies samen een spaardoel',
    rewardCanGet: 'Kan!',
    /** Rustig, buiten het thema Kinderen. */
    rewardCanGetCalm: 'Kan nu',
    rewardMissing: 'Nog {count}',
    rewardWaiting: 'Wacht op papa/mama',
    rewardBusy: 'Eerst de andere',
    rewardLimit: 'Morgen weer',
    rewardSoldOut: 'Op',
    rewardCancel: 'Annuleren',
    whoAreYou: 'Wie ben jij?',
    requestQuestion: '{reward} aanvragen?',
    cancelQuestion: '{reward} toch niet?',
    keepIt: 'Nee, houden',
    cancelYes: 'Ja, toch niet',
    notYou: 'Niet jij?',
    // Wie vinkt af? (na wisselen in de ledenrail, polish w4 ronde 1)
    areYou: 'Ben jij {name}?',
    yesMe: 'Ja, dat ben ik',
    notMe: 'Nee',
    // Wie ben jij? (polish w4 ronde 2): alle gezichten; een ander gezicht wisselt naar die lijst.
    notYours: 'Dit is van {name}',
    notYoursBody: 'Kijk, hier is jouw lijst.',
    closeRewards: 'Terug naar Vandaag',
    // Detail, nacht, rust
    detailClose: 'Sluiten',
    detailEdit: 'Bewerken',
    sleepWell: 'Slaap lekker',
    tomorrowAt: 'Morgen om {time}: {title}',
    calmDown: 'Rustig aan…',
    // Tablet-breed: de Vandaag-kolom van het brede bord ("Binnenkort": verjaardag, feestdag, vakantie).
    upcoming: 'Binnenkort',
    tomorrowEmpty: 'Nog niets gepland',
    inDays: { one: 'over {count} dag', other: 'over {count} dagen' },
};
//# sourceMappingURL=kioskBoard.nl.js.map